import React from 'react';
import { Box, Button } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../i18n/locale-format';
import { Contest } from '../../models/types';
import { SurfaceCard, CardRow } from '../../components/ui/SurfaceCard';
import { EmptyState } from '../../components/ui/EmptyState';

const DAY_MS = 86400000;

export const UpcomingChallengesCard = ({ contests }: { contests: Contest[] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('home');
  return (
    <SurfaceCard
      title={t('upcoming.title')}
      action={<Box component={RouterLink} to="/groups" sx={{ fontSize: 13, color: 'var(--primary)', textDecoration: 'none' }}>{t('upcoming.browseGroups')}</Box>}
      bodyPadding={0}
      sx={{ overflow: 'hidden' }}
    >
      {contests.length === 0 ? (
        <Box sx={{ borderTop: '1px solid var(--border)' }}>
          <EmptyState title={t('upcoming.emptyTitle')} description={t('upcoming.emptyDescription')} />
        </Box>
      ) : (
        contests.map(c => {
          const start = new Date(c.startAt);
          const days = Math.max(0, Math.ceil((start.getTime() - Date.now()) / DAY_MS));
          return (
            <CardRow key={c._id} sx={{ py: '14px' }}>
              <Box sx={{ flex: 'none', width: 44, height: 48, border: '1px solid var(--border)', borderRadius: '9px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1px' }}>
                <Box component="span" sx={{ fontSize: 10, fontWeight: 600, color: 'var(--primary)', letterSpacing: '.06em' }}>
                  {formatDate(start, { month: 'short' }).toUpperCase()}
                </Box>
                <Box component="span" sx={{ fontSize: 17, fontWeight: 600, lineHeight: 1 }}>{start.getDate()}</Box>
              </Box>
              <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <Box sx={{ fontSize: 14, fontWeight: 500, overflowWrap: 'anywhere' }}>{c.name}</Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, fontSize: 12, color: 'var(--muted)' }}>
                  <span>{c.contestType}</span><span>·</span><span>{c.activityType}</span><span>·</span>
                  <span>{days === 0 ? t('upcoming.startsToday') : t('upcoming.startsIn', { count: days })}</span>
                </Box>
              </Box>
              <Button variant="outlined" size="small" onClick={() => navigate(`/contests/${c._id}`)}>{t('upcoming.view')}</Button>
            </CardRow>
          );
        })
      )}
    </SurfaceCard>
  );
};
